import {initParam} from "../setting/initParam";
import {
    calcColumnLine, centeredColumnLineL, createDefaultMaterial, InitialStruct,
    matBeam, MPos,
    ParamsCalcColumnLine,
    ParamsGetSimpleBoard,
    RenderElement,
    RenderStruct,
    simpleSize,
    updateLimitedPointsOnLine
} from "@3dcalc/3dpClient";
import {api} from "../api/api";
import {SpecStructElement, StructData} from "@3dcalc/3dpClient/dist/types/renderElements";
import {locale} from "../setting/locale";

export async function getPillar(s:InitialStruct, sBoard:simpleSize, modeBuild: boolean = false): Promise<StructData> {
    const lang = new URLSearchParams(window.location.search).get('lang') as 'en'|'de'|'ru' || 'en';

    const paramsCalcColumnLine: ParamsCalcColumnLine = {
        l: s.l,
        maxSpan: initParam.setting.pillarMaxSpan,
    }
    const columnLine = calcColumnLine(paramsCalcColumnLine)

    const centeredColumnLine = centeredColumnLineL(columnLine, s.l)
    const lineCenteredCut = updateLimitedPointsOnLine(centeredColumnLine, sBoard.w)
    const lineCut = updateLimitedPointsOnLine(columnLine, sBoard.w)
    const lineCutF1 = updateLimitedPointsOnLine(columnLine, initParam.elementData.f1.sizeBoard.w)
    const lineCutRafter = updateLimitedPointsOnLine(columnLine, initParam.elementData.rafter.sizeBoard.w)

    initParam.maps.pillar.line = columnLine
    initParam.maps.pillar.lineCenteredCut = lineCenteredCut
    initParam.maps.pillar.lineCentered = centeredColumnLine
    initParam.maps.pillar.lineCut = lineCut
    initParam.maps.rafter.lineCut = lineCutRafter
    initParam.maps.f1.lineCut = lineCutF1

    const paramsGetSimpleBoard: ParamsGetSimpleBoard = {
        modeBuild: modeBuild,
        shift: {back: 0, front: 0},
        sizeBoard: {w: sBoard.w, h: sBoard.h, l: sBoard.l},
        cuts: [],
    }
    const rs:RenderStruct = {
        vertices: [],
        indices: [],
        uvs: [],
        material: [],
        elements: [],
        group: ''
    }
    const spec: SpecStructElement[] = []

    rs.material.push(createDefaultMaterial())
    const resultGetSimpleBoard = await api.getSimpleBoard.build(paramsGetSimpleBoard)
    rs.uvs.push(resultGetSimpleBoard.mesh.uvs)
    const numUvs = rs.uvs.length - 1
    rs.indices.push(resultGetSimpleBoard.mesh.indices)
    const numIndices = rs.indices.length - 1
    rs.vertices.push(resultGetSimpleBoard.mesh.vertices)
    const numVertices = rs.vertices.length - 1
    const nameGroup = 'K'
    rs.group = nameGroup
    const numGroups = rs.group.length
    for (let i = 0; i < lineCenteredCut.length; i++) {

        const posL:MPos = [lineCenteredCut[i][0], s.h / 2, +s.w / 2 - sBoard.w / 2]
        const posR:MPos = [lineCenteredCut[i][0], s.h / 2, -s.w / 2 + sBoard.w / 2]

        const boardL: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posL,
            rotation: [0,0,0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardL)
        const boardR: RenderElement = {
            indices: numIndices,
            name: `${nameGroup} - ${i}`,
            nameGroup: nameGroup,
            position: posR,
            rotation: [0,0,0],
            uvs: numUvs,
            vertices: numVertices,
            material: 0,
        }
        rs.elements.push(boardR)
    }
    spec.push({
        w: resultGetSimpleBoard.meta.w,
        h: resultGetSimpleBoard.meta.h,
        l: resultGetSimpleBoard.meta.l,
        name: locale['post'][lang],
        group: locale['posts'][lang],
        count: lineCenteredCut.length * 2,
    })

    return {rs:rs, spec: spec}
}
